import { Triangle } from "react-loader-spinner";
import styles from "./LoadingPage.module.scss";

export const LoadingPage = () => {
  return (
    <div className={styles.LOADING_STYLES}>
      <div className={styles.LOADING_ANIMATION_CONTAINER}>
        <Triangle color="#10D078" height={80} width={80} />
      </div>
    </div>
  );
};
